import React from 'react';
import style from './GreenBlock.module.scss';

const GreenBlock = () => {
    return (
        <div className={style.green_block}></div>
    );
};

export default GreenBlock;
